import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconPaddingVertical12 from './IconPaddingVertical12';
import IconPaddingVertical16 from './IconPaddingVertical16';
import IconPaddingVertical20 from './IconPaddingVertical20';
import IconPaddingVertical24 from './IconPaddingVertical24';
import IconPaddingVertical32 from './IconPaddingVertical32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconPaddingVertical = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconPaddingVertical12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconPaddingVertical16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconPaddingVertical20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconPaddingVertical24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconPaddingVertical32 {...props} />}
        </span>
    );
};
IconPaddingVertical.displayName = 'FondueIconPaddingVertical';

export default memo(IconPaddingVertical);
